export const GET_TOPICS = 'GET_TOPICS';
export const GET_TOPIC = 'GET_TOPIC';
export const TOPICS_ERROR = 'TOPICS_ERROR';
export const ADD_TOPIC = 'ADD_TOPIC';
export const ADD_TOPIC_COMMENT = 'ADD_TOPIC_COMMENT';
export const GET_TOPIC_COMMENTS = 'GET_TOPIC_COMMENTS';
export const CLEAR_TOPICS = 'CLEAR_TOPICS';
export const POST_ERROR = 'POST_ERROR';

 
